/**
 * Component is used to show order summary applied giftCards on the cart page
 *
 * @param {Array}  [appliedGiftCards] - Applied giftCards for current order
 * @param {String} [price-separator] - price separator sign, e.x. 9,10 or 9.10
 * @param {String} [label] - text label to display applied amount on cart summary
 *
 * HTML Structure Example
 * <e2-cart-summary-gift-cards
 *    price-separator=","
 *    label="(e-)GiftCard">
 * </e2-cart-summary-gift-cards>
 *
 */

import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { selectors as cartSelectors } from '@elab/core/store/cart';
import { priceFormatter } from '@elab/core/utils/PriceUtils';

export class CartSummaryGiftCards extends SimpleLitElement {
    static get properties() {
        return {
            appliedGiftCards: { type: Array },
            cssModifier: { type: String, attribute: 'css-modifier' },
            priceSeparator: { type: String, attribute: 'price-separator' },
            label: { type: String },
            priceFirst: { type: Boolean, attribute: 'price-first' },
        };
    }

    constructor() {
        super();
        this.cssModifier = '';
        this.priceSeparator = '.';
        this.label = '';
        this.priceFirst = false;
    }

    render() {
        let currencyISOCode = '';
        const appliedAmount = this.appliedGiftCards.reduce((sum, { appliedAmount = {} }) => {
            currencyISOCode = appliedAmount.currencyIso;
            return sum + appliedAmount.value;
        }, 0);
        const formattedAppliedAmount = priceFormatter(
            appliedAmount,
            currencyISOCode,
            this.priceFirst,
        ).replace('.', this.priceSeparator);

        if (!appliedAmount) return html``;
        return html`
            <div class="cart-summary__row ${this.cssModifier}">
                <p class="cart-summary__row-label">${this.label}</p>
                <e2-price-badge
                    price-label="-"
                    class="cart-summary__price"
                    price="${formattedAppliedAmount}"
                ></e2-price-badge>
            </div>
        `;
    }
}

const mapStateToProps = state => ({
    appliedGiftCards: cartSelectors.getGiftCardTransactions(state),
});

export default () =>
    customElements.define(
        'e2-cart-summary-gift-cards',
        connect(mapStateToProps)(CartSummaryGiftCards),
    );
